(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'd2v-color-js', 'd2v-chord-js', 'd2v-shape-js', 'd2v-viz-js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('d2v-color-js'), require('d2v-chord-js'), require('d2v-shape-js'), require('d2v-viz-js'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'ex-chord-js'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'ex-chord-js'.");
    }
    if (typeof this['d2v-color-js'] === 'undefined') {
      throw new Error("Error loading module 'ex-chord-js'. Its dependency 'd2v-color-js' was not found. Please, check whether 'd2v-color-js' is loaded prior to 'ex-chord-js'.");
    }
    if (typeof this['d2v-chord-js'] === 'undefined') {
      throw new Error("Error loading module 'ex-chord-js'. Its dependency 'd2v-chord-js' was not found. Please, check whether 'd2v-chord-js' is loaded prior to 'ex-chord-js'.");
    }
    if (typeof this['d2v-shape-js'] === 'undefined') {
      throw new Error("Error loading module 'ex-chord-js'. Its dependency 'd2v-shape-js' was not found. Please, check whether 'd2v-shape-js' is loaded prior to 'ex-chord-js'.");
    }
    if (typeof this['d2v-viz-js'] === 'undefined') {
      throw new Error("Error loading module 'ex-chord-js'. Its dependency 'd2v-viz-js' was not found. Please, check whether 'd2v-viz-js' is loaded prior to 'ex-chord-js'.");
    }
    root['ex-chord-js'] = factory(typeof this['ex-chord-js'] === 'undefined' ? {} : this['ex-chord-js'], kotlin, this['d2v-color-js'], this['d2v-chord-js'], this['d2v-shape-js'], this['d2v-viz-js']);
  }
}(this, function (_, Kotlin, $module$d2v_color_js, $module$d2v_chord_js, $module$d2v_shape_js, $module$d2v_viz_js) {
  'use strict';
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var listOf = Kotlin.kotlin.collections.listOf_i5x0yv$;
  var listOf_0 = Kotlin.kotlin.collections.listOf_mh5how$;
  var Color = $module$d2v_color_js.io.data2viz.color.Color;
  var ChordLayout = $module$d2v_chord_js.io.data2viz.chord.ChordLayout;
  var Unit = Kotlin.kotlin.Unit;
  var arc = $module$d2v_shape_js.io.data2viz.shape.arc_7vwo0o$;
  var ribbon = $module$d2v_chord_js.io.data2viz.chord.ribbon_14dthe$;
  var LinearGradient = $module$d2v_color_js.io.data2viz.color.LinearGradient;
  var math = Kotlin.kotlin.math;
  var selectOrCreateSvg = $module$d2v_viz_js.io.data2viz.viz.selectOrCreateSvg;
  var viz = $module$d2v_viz_js.io.data2viz.viz.viz_grhgy9$;
  function Movie(name, avengers) {
    this.name = name;
    this.avengers = avengers;
  }
  Movie.$metadata$ = {kind: Kind_CLASS, simpleName: 'Movie', interfaces: []};
  Movie.prototype.component1 = function () {
    return this.name;
  };
  Movie.prototype.component2 = function () {
    return this.avengers;
  };
  Movie.prototype.copy_m1gs19$ = function (name, avengers) {
    return new Movie(name === void 0 ? this.name : name, avengers === void 0 ? this.avengers : avengers);
  };
  Movie.prototype.toString = function () {
    return 'Movie(name=' + Kotlin.toString(this.name) + (', avengers=' + Kotlin.toString(this.avengers)) + ')';
  };
  Movie.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.name) | 0;
    result = result * 31 + Kotlin.hashCode(this.avengers) | 0;
    return result;
  };
  Movie.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.name, other.name) && Kotlin.equals(this.avengers, other.avengers)))));
  };
  function Avenger(name) {
    this.name = name;
  }
  Avenger.$metadata$ = {kind: Kind_CLASS, simpleName: 'Avenger', interfaces: []};
  Avenger.prototype.component1 = function () {
    return this.name;
  };
  Avenger.prototype.copy_61zpoe$ = function (name) {
    return new Avenger(name === void 0 ? this.name : name);
  };
  Avenger.prototype.toString = function () {
    return 'Avenger(name=' + Kotlin.toString(this.name) + ')';
  };
  Avenger.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.name) | 0;
    return result;
  };
  Avenger.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && Kotlin.equals(this.name, other.name))));
  };
  var blackWidow;
  var captainAmerica;
  var theHulk;
  var ironMan;
  var thor;
  var hawkeye;
  var movies;
  var avengers;
  var colors;
  var width;
  var height;
  var outer;
  var inner;
  var chord;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_ww73n8$;
  function collaborations(avengers) {
    var $receiver = movies;
    var destination = ArrayList_init();
    var tmp$;
    tmp$ = $receiver.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      if (element.avengers.containsAll_brywnq$(avengers))
        destination.add_11rb$(element);
    }
    return destination.size;
  }
  function chords$lambda(a, b) {
    return (a != null ? a.equals(b) : null) ? 0.0 : collaborations(listOf([a, b]));
  }
  var chords;
  function arc$lambda$lambda(it) {
    return inner + 3;
  }
  function arc$lambda$lambda_0(it) {
    return outer;
  }
  function arc$lambda$lambda_1(it) {
    return it.startAngle;
  }
  function arc$lambda$lambda_2(it) {
    return it.endAngle;
  }
  function arc$lambda($receiver) {
    $receiver.innerRadius = arc$lambda$lambda;
    $receiver.outerRadius = arc$lambda$lambda_0;
    $receiver.startAngle = arc$lambda$lambda_1;
    $receiver.endAngle = arc$lambda$lambda_2;
    return Unit;
  }
  var arc_0;
  var ribbon_0;
  function chordViz$lambda($receiver) {
    $receiver.translate_lu1900$(width / 2, height / 2);
    return Unit;
  }
  function chordViz$lambda$lambda(closure$index, closure$it) {
    return function ($receiver) {
      $receiver.fill = colors.get_za3lpa$(closure$index);
      $receiver.stroke = null;
      arc_0.arc_htbjw1$(closure$it, $receiver);
      return Unit;
    };
  }
  var Math_0 = Math;
  function chordViz$toGradient($receiver) {
    var $receiver_0 = new LinearGradient();
    var tmp$ = inner;
    var x = ($receiver.source.endAngle - $receiver.source.startAngle) / 2 + $receiver.source.startAngle - math.PI / 2;
    $receiver_0.x1 = tmp$ * Math_0.cos(x);
    var tmp$_0 = inner;
    var x_0 = ($receiver.source.endAngle - $receiver.source.startAngle) / 2 + $receiver.source.startAngle - math.PI / 2;
    $receiver_0.y1 = tmp$_0 * Math_0.sin(x_0);
    var tmp$_1 = inner;
    var x_1 = ($receiver.target.endAngle - $receiver.target.startAngle) / 2 + $receiver.target.startAngle - math.PI / 2;
    $receiver_0.x2 = tmp$_1 * Math_0.cos(x_1);
    var tmp$_2 = inner;
    var x_2 = ($receiver.target.endAngle - $receiver.target.startAngle) / 2 + $receiver.target.startAngle - math.PI / 2;
    $receiver_0.y2 = tmp$_2 * Math_0.sin(x_2);
    var $receiver_1 = colors.get_za3lpa$($receiver.source.index);
    $receiver_1.alpha = 0.6;
    $receiver_0.addColor_vcv3pf$(0.0, $receiver_1);
    var $receiver_2 = colors.get_za3lpa$($receiver.target.index);
    $receiver_2.alpha = 0.6;
    $receiver_0.addColor_vcv3pf$(1.0, $receiver_2);
    return $receiver_0;
  }
  function chordViz$lambda$lambda_0(closure$chord, closure$toGradient) {
    return function ($receiver) {
      $receiver.fill = closure$toGradient(closure$chord);
      $receiver.stroke = null;
      ribbon_0(closure$chord, $receiver);
      return Unit;
    };
  }
  function chordViz($receiver) {
    $receiver.transform_tabxxp$(chordViz$lambda);
    var tmp$, tmp$_0;
    var index = 0;
    tmp$ = chords.groups.iterator();
    while (tmp$.hasNext()) {
      var item = tmp$.next();
      $receiver.path_saeswf$(chordViz$lambda$lambda((tmp$_0 = index, index = tmp$_0 + 1 | 0, tmp$_0), item));
    }
    var toGradient = chordViz$toGradient;
    var tmp$_1;
    tmp$_1 = chords.chords.iterator();
    while (tmp$_1.hasNext()) {
      var element = tmp$_1.next();
      $receiver.path_saeswf$(chordViz$lambda$lambda_0(element, toGradient));
    }
  }
  function main$lambda($receiver) {
    chordViz($receiver);
    return Unit;
  }
  function main(args) {
    var $receiver = selectOrCreateSvg();
    $receiver.setAttribute('width', '600.0');
    $receiver.setAttribute('height', '600.0');
    var root = $receiver;
    viz(root, main$lambda);
  }
  var package$io = _.io || (_.io = {});
  var package$data2viz = package$io.data2viz || (package$io.data2viz = {});
  var package$examples = package$data2viz.examples || (package$data2viz.examples = {});
  var package$chord = package$examples.chord || (package$examples.chord = {});
  package$chord.Movie = Movie;
  package$chord.Avenger = Avenger;
  package$chord.collaborations_batyw5$ = collaborations;
  package$chord.chordViz_b0as1z$ = chordViz;
  package$chord.main_kand9s$ = main;
  var collectionSizeOrDefault = Kotlin.kotlin.collections.collectionSizeOrDefault_ba2ldo$;
  blackWidow = new Avenger('Black Widow');
  captainAmerica = new Avenger('Captain America');
  theHulk = new Avenger('the Hulk');
  ironMan = new Avenger('Iron Man');
  thor = new Avenger('Thor');
  hawkeye = new Avenger('hawkeye');
  movies = listOf([new Movie('Avengers', listOf([ironMan, captainAmerica, theHulk, thor, hawkeye, blackWidow])), new Movie("Avengers, L'\xE8re d'Ultron", listOf([ironMan, captainAmerica, theHulk, thor, hawkeye, blackWidow])), new Movie('Avengers, Infinity War', listOf([ironMan, captainAmerica, theHulk, hawkeye, blackWidow])), new Movie('Captain America, First Avenger', listOf_0(captainAmerica)), new Movie("Captain America, Le Soldat de l'hiver", listOf([captainAmerica, blackWidow])), new Movie('Captain America, Civil War', listOf([captainAmerica, ironMan, hawkeye, blackWidow])), new Movie('Iron Man 1', listOf_0(ironMan)), new Movie('Iron Man 2', listOf([ironMan, blackWidow])), new Movie('Iron Man 3', listOf([ironMan, theHulk])), new Movie('Thor', listOf([thor, hawkeye])), new Movie('Thor, le monde des t\xE9n\xE8bres', listOf([thor, captainAmerica])), new Movie('Thor, Ragnarok', listOf([thor, theHulk]))]);
  avengers = listOf([blackWidow, captainAmerica, hawkeye, theHulk, ironMan, thor]);
  var $receiver = listOf([3153438, 540279, 3416912, 5665333, 9115164, 14646272]);
  var destination = ArrayList_init(collectionSizeOrDefault($receiver, 10));
  var tmp$;
  tmp$ = $receiver.iterator();
  while (tmp$.hasNext()) {
    var item = tmp$.next();
    destination.add_11rb$(new Color(item));
  }
  colors = destination;
  width = 600.0;
  height = width;
  var a = width;
  var b = height;
  outer = Math_0.min(a, b) * 0.5 - 40.0;
  inner = outer - 30;
  var $receiver_0 = new ChordLayout();
  $receiver_0.padAngle = 0.15;
  chord = $receiver_0;
  chords = chord.chord_5nmfia$(avengers, chords$lambda);
  arc_0 = arc(arc$lambda);
  ribbon_0 = ribbon(inner);
  main([]);
  return _;
}));

//# sourceMappingURL=ex-chord-js.js.map



//////////////////
// WEBPACK FOOTER
// ./build/kotlin-js-min/main/ex-chord-js.js
// module id = 5
// module chunks = 0